import { EpimsBaseEntityDto } from './epim-base.dto';

export class LessorsDto extends EpimsBaseEntityDto {
  LessorsId: string;
  PaymentTypeId: string;
  OwnershipTypeId: string;
  Owners: string;
  LandType: string;
  Status: string;
  Area: number;
  Rate: number;
  Amount: number;
  Remarks: string;
  Address: string;
  BankName: string;
  BankCode: string;
  PhoneNumber: string;
  SubscriberId: string;
  SubscriptionUserId: string;
  Payment: string;
  LandTitleSerialNo: string;
  ItemTypeId: string;
  ItemName: string;
  CompanyApprovedRate: number;
  Qty: number;
  ItemId: string;
  Type: string;
  ApprovalStatus: string;
  PaymentStatus: string;
  BatchId: string;
  PaymentDate: Date;
  NegotiatedAmount: number;
  LossOfUseItemId: string;
  ModifiedBy: string;
  MeasureId: string;
  ApprovalRemarks: string;
  ApprovalDate: Date;
  ApprovalPersonId: string;
  ApprovalPersonName: string;
  Ra: string;
  DistributorFactorValue: number;
  DistributorFactorName: string;
  Rdf: boolean;
  MeasureName: string;
  LessorInfo_LesssorId: string;
  Terrain_TerrainId: string;
  AddressBook_AddressBookId: string;
  PaymentType: string;
  ownerName: string;
  BulkPaymentStatus_text: string;
  BulkPaymentStatus_value: string;
  OwnershipTypeName: string;
  TerrianName: string;
  PaymentRemarks: string;
  UomId: string;
  IncidentQuantumId: string;
}
